<style lang="scss" scoped>
.back_form {
  &-key {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    padding: 25px 55px;
    line-height: 22px;
    &_m {
      color: #e62412;
    }
  }
  &-input {
    margin-top: 8px;
    margin-bottom: 16px;
  }
  .input-m {
  }
}
.URLBox {
  display: flex;
  height: 48px;

  line-height: 44px;

  .URL {
    width: 100%;
    margin-right: 16px;
    background: #f2fbff;
    border-radius: 4px;
    padding: 0 15px;
    min-width: 600px;
    border: 1px solid #ccecff;
  }
}
</style>
<template>
  <div>
    <FormHead :images="require('@/assets/img/qwLogin/two.png')" />
    <BtnBar
      title="第三步 授权通信录"
      desc="提交信息"
      to-path="/"
    />
    <!-- 一 -->
    <Block
      :title="block1.title"
      :desc="block1.desc"
      :images="block1.images"
    >
      <template
        v-slot:form
        class="back_form"
      >
        >
        <div class="back_form-key">
          <span class="back_form-key_m"> * </span>Secret：
          <div class="back_form-input">
            <el-input
              v-model="form.secret"
              placeholder="请输入Secret"
              class="m-r-6"
              clearable
              @input="formInput('secret')"
            />
          </div>
        </div>
      </template>
    </Block>
    <!-- 二 -->
    <Block
      :title="block2.title"
      :desc="block2.desc"
      :images="block2.images"
    />
    <!-- 三 -->
    <!-- 四 -->
    <Block
      :title="block3.title"
      :desc="block3.desc"
      :images="block3.images"
    >
      <template
        v-slot:form
        class="back_form"
      >
        <div class="back_form-key">
          URL:
          <div class="back_form-input">
            <div class="URLBox">
              <div class="URL">
                <el-button
                  type="text"
                  @click="touchUrl('http://www.shopex.cn')"
                >
                  http://www.shopex.cn
                </el-button>
              </div>
              <el-button
                v-clipboard:copy="'http://www.shopex.cn'"
                v-clipboard:success="onCopy"
                type="primary"
                class="btn"
                style="height: 36px; margin-top: 6px"
              >
                复制
              </el-button>
            </div>
          </div>
          <span class="back_form-key_m"> * </span>token:
          <div class="back_form-input">
            <el-input
              v-model="form.token"
              placeholder="请输入token"
              class="m-r-6"
              clearable
              @input="formInput('token')"
            />
          </div>
          <span class="back_form-key_m"> * </span>EncomingAESKey：
          <div class="back_form-input">
            <el-input
              v-model="form.aes_key"
              placeholder="请输入EincomingAESKey"
              class="m-r-6"
              clearable
              @input="formInput('aes_key')"
            />
          </div>
        </div>
      </template>
    </Block>
    <!-- 四 -->
    <Block
      :title="block4.title"
      :desc="block4.desc"
      :images="block4.images"
    />
    <!-- 五 -->
    <Block
      :title="block5.title"
      :desc="block5.desc"
      :images="block5.images"
    />

    <BtnBar
      title="第三步 授权通信录"
      desc="提交信息"
      to-path="/"
    />
    <FootBar />
  </div>
</template>

<script>
import FormHead from './comps/form/head'
import Block from './comps/form/block'
import FootBar from './comps/form/footBar'
import BtnBar from './comps/form/btnBar'
import { mapGetters } from 'vuex'
import { setOpenworkwechat } from '@/api/qwAuth'
export default {
  components: {
    FormHead,
    Block,
    FootBar,
    BtnBar
  },
  data () {
    return {
      form: {
        aes_key: null,
        secret: null,
        token: null
      },
      loading: null,
      block1: {
        title: `一、切换到「管理工具」- 「通讯录管理」，点击「开启API接口同步」展开，点击「Secret」后的「查看」按钮，获取Secret。该Secret会发送到当前登录的管理员账号的企业微信内，管理员在企业微信内复制后粘贴到下方`,
        images: require(`@/assets/img/qwLogin/info/3-1.png`)
      },
      block2: {
        title: `二、点击「设置接收事件服务器」。`,
        images: require(`@/assets/img/qwLogin/info/3-2.png`)
      },
      block3: {
        title: `三、首先将下方的URL复制粘贴至下图「URL」处。再分别点击「Token」和「EncomingAESKey」后面的「随机获取」按钮，将获取到的值复制填写至下方。`,
        images: require(`@/assets/img/qwLogin/info/3-3.png`)
      },
      block4: {
        title: `四、首先将下方的URL复制粘贴至下图「URL」处。再分别点击「Token」和「EncomingAESKey」后面的「随机获取」按钮，将获取到的值复制填写至下方。`,
        images: require(`@/assets/img/qwLogin/info/3-4.png`)
      },
      block5: {
        title: `五、首先将下方的URL复制粘贴至下图「URL」处。再分别点击「Token」和「EncomingAESKey」后面的「随机获取」按钮，将获取到的值复制填写至下方。`,
        images: require(`@/assets/img/qwLogin/info/3-5.png`)
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapGetters(['companyConfig'])
  },
  methods: {
    onCopy () {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    //设置部分配置详情
    subsetOpenworkwechat () {
      let params = {
        //备注: 外部联系人管理的信息配置
        external_contact: this.companyConfig.external_contact,
        //备注: 通讯录的信息配置
        contacts: this.companyConfig.contacts
      }

      // if(params.)
      try {
        setOpenworkwechat(params).then((res) => {
          console.log('设置部分配置详情', res)
          if (res.status) {
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            this.$router.push({ path: '/' })
          }
        })
      } catch (error) {
        console.log('设置部分配置详情-error', error)
      }
    },
    subConfig () {
      this.$store.commit('SETCompanyConifg', { key: 'contacts', val: this.form })
      this.subsetOpenworkwechat()
    },
    formInput (key) {
      // console.log(key,this.form[key])
    },
    touchUrl (Url) {
      window.open(Url)
    },
    async init () {}
  }
}
</script>
